module.exports = "<div class=\"button-bar\">\n  <a class=\"btn btn-link\" (click)=\"cancelClick()\" data-se-id=\"cancelButton\">{{'COMMON.BUTTON.CANCEL'\n    | translate}}</a>\n  <button type=\"button\" [disabled]=\"!eventForm.valid\" (click)=\"saveClick()\" class=\"btn btn-primary\" data-se-id=\"saveButton\">\n    {{'COMMON.BUTTON.SAVE' | translate}}\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/add-event-button-bar/add-event-button-bar.component.html
// module id = eyPP
// module chunks = 0